import React, { useState } from "react";

const TIPOS = ["Anel Feminino", "Solitário Feminino", "Anel Masculino"];
const CATEGORIAS = [
  "Feminino, Joia > Anéis, Joia > Lançamentos",
  "Feminino, Joia > Anéis, Joia > Solitários",
  "Masculino, Joia > Anéis",
  "Feminino, Joia > Anéis, Joia > Lançamentos, Mais vendidos",
];

function tipoDefaults(tipo) {
  if (tipo === "Solitário Feminino")
    return { categorias: CATEGORIAS[1], preco: "159.90", preco_promo: "99.90" };
  if (tipo === "Anel Masculino")
    return { categorias: CATEGORIAS[2], preco: "210.00", preco_promo: "149.90" };
  return { categorias: CATEGORIAS[0], preco: "210.00", preco_promo: "149.90" };
}

const defaults = {
  nome: "", tipo: "Anel Feminino", categorias: CATEGORIAS[0],
  preco: "210.00", preco_promo: "149.90", peso: "0.30",
  altura: "5.00", largura: "5.00", comprimento: "5.00",
  custo: "8.00", descricao: "", exibir: "SIM", frete_gratis: "NÃO",
  marca: "Lyore", produto_fisico: "SIM", faixa_etaria: "Adulto",
};

export default function ProductModal({ mode, product, onSave, onClose }) {
  const initial = mode === "edit" ? { ...defaults, ...product } : { ...defaults };
  const [form, setForm] = useState(initial);
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(product?.image_url || null);
  const [saving, setSaving] = useState(false);

  const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  const onTipoChange = (tipo) => {
    const d = tipoDefaults(tipo);
    setForm((f) => ({ ...f, tipo, ...d }));
  };

  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome.trim()) return alert("Nome é obrigatório");
    setSaving(true);
    const data = { ...form };
    delete data.id;
    delete data.slug;
    delete data.image_url;
    delete data.created_at;
    delete data.updated_at;
    await onSave(data, imageFile);
    setSaving(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === "edit" ? "Editar Produto" : "Novo Produto"}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-row">
            <label>Nome do Produto</label>
            <input value={form.nome} onChange={(e) => set("nome", e.target.value)} required />
          </div>

          <div className="form-row">
            <label>Tipo</label>
            <select value={form.tipo} onChange={(e) => onTipoChange(e.target.value)}>
              {TIPOS.map((t) => <option key={t}>{t}</option>)}
            </select>
          </div>

          <div className="form-row">
            <label>Categorias</label>
            <select value={form.categorias} onChange={(e) => set("categorias", e.target.value)}>
              {CATEGORIAS.map((c) => <option key={c}>{c}</option>)}
            </select>
          </div>

          <div className="form-grid-3">
            <div className="form-row">
              <label>Preco</label>
              <input value={form.preco} onChange={(e) => set("preco", e.target.value)} />
            </div>
            <div className="form-row">
              <label>Promocao</label>
              <input value={form.preco_promo} onChange={(e) => set("preco_promo", e.target.value)} />
            </div>
            <div className="form-row">
              <label>Custo</label>
              <input value={form.custo} onChange={(e) => set("custo", e.target.value)} />
            </div>
          </div>

          <div className="form-grid-4">
            <div className="form-row">
              <label>Peso (kg)</label>
              <input value={form.peso} onChange={(e) => set("peso", e.target.value)} />
            </div>
            <div className="form-row">
              <label>Altura</label>
              <input value={form.altura} onChange={(e) => set("altura", e.target.value)} />
            </div>
            <div className="form-row">
              <label>Largura</label>
              <input value={form.largura} onChange={(e) => set("largura", e.target.value)} />
            </div>
            <div className="form-row">
              <label>Comp.</label>
              <input value={form.comprimento} onChange={(e) => set("comprimento", e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <label>Marca</label>
            <input value={form.marca} onChange={(e) => set("marca", e.target.value)} />
          </div>

          <div className="form-grid-3">
            <div className="form-row">
              <label>Exibir</label>
              <select value={form.exibir} onChange={(e) => set("exibir", e.target.value)}>
                <option>SIM</option><option>NÃO</option>
              </select>
            </div>
            <div className="form-row">
              <label>Frete Gratis</label>
              <select value={form.frete_gratis} onChange={(e) => set("frete_gratis", e.target.value)}>
                <option>SIM</option><option>NÃO</option>
              </select>
            </div>
            <div className="form-row">
              <label>Faixa Etaria</label>
              <select value={form.faixa_etaria} onChange={(e) => set("faixa_etaria", e.target.value)}>
                <option>Adulto</option>
                <option>0 a 3 meses</option>
                <option>3 a 12 meses</option>
                <option>1 a 5 anos</option>
                <option>5 a 13 anos</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <label>Descricao (HTML)</label>
            <textarea rows={5} value={form.descricao} onChange={(e) => set("descricao", e.target.value)} />
          </div>

          <div className="form-row">
            <label>Imagem do Produto</label>
            <input type="file" accept="image/*" onChange={onImageChange} />
            {preview && <img src={preview} alt="preview" className="image-preview" />}
          </div>

          {mode === "edit" && form.sku && (
            <div className="form-row">
              <label>SKU</label>
              <input value={form.sku} disabled />
            </div>
          )}

          <div className="modal-actions">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Salvando..." : "Salvar"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
